import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Settings } from "lucide-react"
import { useAuth } from "@/components/providers/auth-provider"

export function AccountStatus() {
  const { user } = useAuth()
  
  const getTierDisplayName = (tier?: string) => {
    if (!tier) return 'No Plan'
    
    // Handle both uppercase and lowercase
    const lowerTier = tier.toLowerCase()
    switch (lowerTier) {
      case 'creator':
        return 'Creator'
      case 'professional':
        return 'Professional'
      case 'agency':
        return 'Agency'
      default:
        // Fallback: just capitalize first letter
        return tier.charAt(0).toUpperCase() + tier.slice(1).toLowerCase()
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Settings className="w-5 h-5" />
          Account Status
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span>Credits Remaining:</span>
            <div className="flex items-center w-32">
              <span className="w-4"></span>
              <span className="ml-2 font-medium">{user?.credits || 0} minutes</span>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <span>X Account:</span>
            <div className="flex items-center w-32">
              <span className="w-4 flex justify-center text-black">✓</span>
              <span className="ml-2 font-medium text-black">Connected</span>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <span>Phone Verified:</span>
            <div className="flex items-center w-32">
              <span className={`w-4 flex justify-center ${user?.phoneVerified ? "text-black" : "text-gray-500"}`}>
                {user?.phoneVerified ? "✓" : "⚠"}
              </span>
              <span className={`ml-2 font-medium ${user?.phoneVerified ? "text-black" : "text-gray-500"}`}>
                {user?.phoneVerified ? "Verified" : "Pending"}
              </span>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <span>Subscription:</span>
            <div className="flex items-center w-32">
              <span className={`w-4 flex justify-center ${user?.subscription?.tier ? "text-black" : "text-gray-500"}`}>
                {user?.subscription?.tier ? "✓" : "⚠"}
              </span>
              <span className={`ml-2 font-medium ${user?.subscription?.tier ? "text-black" : "text-gray-500"}`}>
                {user?.subscription?.tier ? getTierDisplayName(user?.subscription?.tier) : 'No Plan'}
              </span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}